import {UI} from "../../stem-core/src/ui/UIBase.js";
import {styleRule, styleRuleInherit, StyleSheet} from "../../stem-core/src/ui/Style.js";
import {registerStyle} from "../../stem-core/src/ui/style/Theme.js";
import {Link} from "../../stem-core/src/ui/primitives/Link.jsx";
import {DEFAULT_TRANSITION} from "../../blink-sdk/Constants.js";

export class BlinkLinkStyle extends StyleSheet {
    @styleRule
    container = {
        cursor: "pointer",
        color: this.themeProps.MERCHANT_TEXT_LINK_COLOR,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        fontSize: "inherit",
        ":hover": {
            color: this.themeProps.MERCHANT_TEXT_LINK_COLOR_HOVER,
            textDecoration: "underline",
        },
    };
}

class LinkButtonStyle extends BlinkLinkStyle {
    @styleRuleInherit
    container = {
        userSelect: "none",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        transition: DEFAULT_TRANSITION,
        fontWeight: "initial",
        ":hover": {
            textDecoration: null,
        },
    }

    @styleRule
    centered = {
        margin: "12px auto",
        width: this.themeProps.FIT_CONTENT,
        display: "block",
    }

    @styleRule
    disabled = {
        pointerEvents: "none",
        cursor: "not-allowed",
    };

    @styleRule
    invisible = {
        opacity: 0,
    };
}

// TODO temp class to just collect all random divs that have a link button style attached to them.
//  Should probably be a tertiary button
//  Have two modes - inline or centered per line
@registerStyle(LinkButtonStyle)
export class LinkButton extends Link {
    extraNodeAttributes(attr) {
        const {styleSheet} = this;
        const {disabled, invisible, centered} = this.options;

        if (disabled || invisible) {
            attr.addClass(styleSheet.disabled);
        }

        if (invisible) {
            attr.addClass(styleSheet.invisible);
        }

        if (centered) {
            attr.addClass(styleSheet.centered);
        }
    }
}
